<template>
	<div class="brand_box">
		<div class="wrap" ref='shop'>
			<div v-show="shopShow" class="top animate__animated animate__fadeInUp">
				部分已合作商家展示
				<!-- <span>截止目前全国品牌商户合作1000+，服务100万+用户</span> -->
			</div>
			<div class="phoneBj">
				<ul ref="oem">
					<li v-show="oemShow" class="animate__animated animate__fadeInUp" v-for="(item,index) in brandList" :key='index'>
						<img :src="imageHttp(item.image)" >
					</li>
					
				</ul>
			</div>
			
		</div>
	</div>
</template>

<script>
	import { imageHttp } from '@/static/js/utils.js'
	import { indexBrand } from '@/api'
	export default{
		data() {
			return{
				oemShow:false,
				shopShow:false,
				brandList:[],													//品牌展示 列表
			}
		},
		mounted() {
			this.getIndexBrand()
			window.addEventListener("scroll", this.handleScroll);
			window.addEventListener("scroll", this.handle);
		},
		methods:{
			imageHttp,
			//获取品牌展示 
			getIndexBrand(){
				indexBrand().then(res => {
					if(res.code == 200){
						// console.log(res)
						this.brandList = res.data.list
					}else{
						console.log(res.msg)
					}
				})
			},
			handleScroll () { // 实现当滚动到指定位置，触发动画
				// let scrollTop =  window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop // 获取窗口滚动条高度
				// this.gdjz('earth', 'earth animated bounceInDown', 50)
				let _this = this
				let refArray = [
					{ref: 'shop', show: 'shopShow'},
					{ref: 'oem', show: 'oemShow'},
			      ]
				  // console.log(refArray)
				refArray.forEach((r,i) => {
					_this.gdjz(r.ref, 20, () => {
						_this[r.show] = true
					})
				})
			},
			gdjz(div, offset, callback) {
				let dom = this.$refs[div] // 等同于document.querySelector('.earth') true
				// console.log(dom)
				if(dom){
					var a,b,c,d;
					d = dom.offsetTop // 元素距离相对父级的高度，这里父级指的是body
					a = eval(d + offset)
					b = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop //  获取窗口滚动条高度
					c = document.documentElement.clientHeight || document.body.clientHeight // 获取浏览器可视区的高度
					if( b + c > a ) {
						callback && callback()
					}
				}
			},
			handle () { // 实现当滚动到指定位置，触发动画
				// let scrollTop =  window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop // 获取窗口滚动条高度
				// this.gdjz('earth', 'earth animated bounceInDown', 50)
				let _this = this
				let refArray = [
					{ref: 'shop', show: 'shopShow'},
					{ref: 'oem', show: 'oemShow'},
			      ]
				  // console.log(refArray)
				refArray.forEach((r,i) => {
					_this.gd(r.ref, 20, () => {
						_this[r.show] = false
					})
				})
			},
			gd(div, offset, callback) {
				let dom = this.$refs[div] // 等同于document.querySelector('.earth') true
				// console.log(dom)
				if(dom){
					var a,b,c,d;
					d = dom.offsetTop // 元素距离相对父级的高度，这里父级指的是body
					a = eval(d + offset)
					b = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop //  获取窗口滚动条高度
					c = document.documentElement.clientHeight || document.body.clientHeight // 获取浏览器可视区的高度
					if( b + c < a ) {
						callback && callback()
					}
				}
			},
		}
	}
</script>

<style lang="scss" scoped>
	@media (max-width:1026px){
		.brand_box{
			// margin-top: 0.45rem !important;
			width: 100%;
			// height: 5.15rem ;
			background-image:none !important;
			background-color: #fff !important;
			// background: url(../../../public/images/bj.png) no-repeat center center;
			// background-size: 1920px 7.3rem;
			display: flex;
			flex-direction: column;
			align-items: center;
			margin-bottom: 0.5rem;
			
			.wrap{
				width: 100% !important;
				// height: 5.15rem !important;
				
				.top{
					font-size: 0.32rem !important;
					margin-top: 0.59rem !important;
					span{
						font-size: 0.24rem !important;
						margin-top: 0.19rem !important;
					}
				}
				.phoneBj{
					width: 100% !important;
					// height: 5.15rem !important;
					background: url(../../../public/images/phoneBj.png) repeat ;
					background-size:100% 5.15rem;
					display: flex;
					justify-content: center;
					margin-top: 0.5rem;
					ul{
						width: 6.89rem !important;
						// height: 2.82rem !important;
						margin-top: 0rem !important;
						margin-bottom: 36px;
						li{
							width: 1.29rem !important;
							// height: 0.86rem !important;
							display: flex;
							justify-content: center;
							align-items: center;
							background-size:1rem 0.5rem;
						}
					}
				}
			}
		}
	}
	
	
	.brand_box{
		// margin-top: 0.62rem;
		width: 100%;
		// height: 7.3rem;
		background: url(../../../public/images/bj.png) no-repeat center center;
		background-size: 1920px 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
		// padding-bottom: 0.2rem;
		margin-bottom: 0.5rem;
		
		.wrap{
			width: 13rem;
			// height: 7.3rem;
			display: flex;
			align-items: center;
			flex-direction: column;
			.top{
				font-size: 0.28rem;
				color: #000000;
				display: flex;
				align-items: center;
				flex-direction: column;
				margin-top: 0.4rem;
				span{
					font-size: 0.18rem;
					color: #999999;
					margin-top: 0.18rem;
				}
			}
			.phoneBj{
				margin-top: 0.2rem;
				
			}
			ul{
				width: 13rem;
				display: flex;
				flex-wrap: wrap;
				// justify-content: space-between;
				margin-top: 0.2rem;
				margin-left: 66px;
				li{
					width: 1.33rem;
					height: 1.33rem;
					box-shadow: 0rem 0.06rem 0.08rem 0rem rgba(0, 0, 0, 0.04);
					border-radius: 0.2rem;
					margin-top: 0.2rem;
					display: flex;
					justify-content: center;
					align-items: center;
					// background-color: #fff;
					margin-right: 0.2rem;
					background-size:1.74rem 0.87rem;
					
					
					img{
						width: 1.33rem;
						height: 1.33rem;
					}
				}
			}
		}
	}
	
	
</style>
